<section class="siteSettingsIntegrationsCustomFields">
  <div class="integrationFieldsDescription">
    <header class="integrationFieldsDescription__header">
      {{ 'integrations_voly_custom_fields_header' | ppTranslate }}
    </header>

    <p class="integrationFieldsDescription__subheader">
      {{ 'integrations_voly_custom_fields_subheader' | ppTranslate }}
    </p>
  </div>

  <div class="integrationFields">
    @for (field of integrationFields; track field; let last = $last) {
      <div class="integrationFieldContainer">
        <pp-site-settings-integrations-custom-field-row
          [ppField]="field"
          [ppDisabled]="disabled"
          [ppWorkspaceId]="ppWorkspaceId"
        ></pp-site-settings-integrations-custom-field-row>
        @if (!last) {
          <hr class="integrationFieldSpacer" />
        }
      </div>
    }
  </div>
</section>
